import { Carousel } from '../../views/ts/components/Carousel';
import { Collapse } from '../../views/ts/components/Collapse';
import { LazyLoader } from '../../views/ts/components/LazyLoader';
import { Header } from '../../views/twig/components/Header';
import { Menu } from '../../views/twig/components/Menu';
import { ParallaxeImage } from '../../views/twig/components/ParallaxeImage';
import { Projects } from '../../views/twig/modules/projects/index';
import { ProjectsFeatured } from '../../views/twig/modules/projects_featured/index';
import { Timeline } from '../../views/twig/modules/timeline/index';
import { Testimonials } from '../../views/twig/modules/testimonials/index';
import { Map } from '../../views/twig/modules/map/index';
import { Team } from '../../views/twig/modules/team/index';
import { News } from '../../views/twig/modules/news/index';
//(new Analytics()).init();
(new Carousel()).init();
(new Collapse()).init();
//(new Demo()).init();
//(new Dropdown()).init();
(new LazyLoader()).init();
//(new ScrollSpy()).init();
//(new DarkMode()).init();
(new Header()).init();
(new Menu()).init();
(new ParallaxeImage()).init();
(new Projects()).init();
(new ProjectsFeatured()).init();
(new Timeline()).init();
(new Testimonials()).init();
(new Map()).init();
(new Team()).init();
(new News()).init();
// Always at the end
//(new CookiesConsent()).init();
